import { PriceZoneModelType } from '@teinor/erp/types/company/priceZone'
import { useParams } from 'react-router-dom'
import ModalDeletePriceZone from './DeleteModalPriceZone'
import ModalCESPriceZone from './ModalCESPriceZone'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderCountryName, CustomRenderStateName, DeleteRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { useBasicData } from '../../../../../../../utils/hooks/useBasicData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getDictionaryCountries } from '../../../../../../../utils/reducers/getters'

interface SinglePriceZoneProps extends ComponentWithPermissions { }

const SinglePriceZone: React.FC<SinglePriceZoneProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const { PriceZoneGroupId } = useParams()
    useBasicData({ params: { id: PriceZoneGroupId }, url: '/api/app/product/priceZoneGroup/getPriceZoneGroupInstance', variableToCurrentPage: 'name', doPetition: PriceZoneGroupId !== 'main' })
    const pageData = {
        title: t('priceZone', 'Zona de precios'),
        newText: t('createNewZone', 'Crear nueva zona')
    }

    return (
        <BaseScreenTable TableComponent={SinglePriceZoneTable} CreateModalComponent={ModalCESPriceZone} DeleteModalComponent={ModalDeletePriceZone} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface SinglePriceZoneTableProps extends TableComponentProps { }

const SinglePriceZoneTable: React.FC<SinglePriceZoneTableProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const { PriceZoneGroupId } = useParams()
    const countries = getDictionaryCountries()

    const columns: ColumnTableSchema<PriceZoneModelType> = [
        {
            id: 'country',
            dataKey: 'country',
            label: t('country', 'País'),
            customRender: (parameterValue) => <CustomRenderCountryName countryId={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: countries, label: t('country', 'País') }
            },
            generalSearchable: false
        },
        {
            id: 'state',
            dataKey: 'state',
            label: t('state', 'Provincia'),
            customRender: (parameterValue, allRowData) => <CustomRenderStateName stateId={parameterValue} allRowData={allRowData} />,
        },
        {
            id: 'postal_code',
            dataKey: 'postal_code',
            label: t('postalCode', 'Código postal')
        },
        {
            id: 'delete',
            dataKey: 'country',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable className='single_price_zone_table hide_searchbar' columns={columns} getDataFrom='/api/app/product/priceZoneGroup/priceZone/getAllPriceZonesInner' name='priceZones' extraWhereParams={{ PriceZoneGroupId }} defaultOrder={{ defaultOrderField: 'PriceZoneGroupId' }} setTableInstance={setTableInstance} hideLoadFiltersButton={true}   />
    )
}

export default SinglePriceZone